import { Link } from "react-router-dom";
import { CATEGORIES, shopCategoryUrl } from "@/lib/site";

export const CategoryLinks = ({ className = "font-semibold underline underline-offset-4 hover:text-brand-red" }) => (
  <>
    {CATEGORIES.map((c, i) => (
      <span key={c.slug}>
        <Link to={shopCategoryUrl(c.slug)} className={className} data-testid={`inline-cat-${c.slug}`}>{c.name.toLowerCase()}</Link>
        {i < CATEGORIES.length - 2 ? ", " : i === CATEGORIES.length - 2 ? " and " : ""}
      </span>
    ))}
  </>
);
